/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow

// Places allows at most 5, and offers no "address" collection to use instead.
export const ADDRESS_PRIMARY_TYPES: Array<string> = [
  'street_address',
  'premise',
  'subpremise',
  'route',
];

const isAddressPrediction = (prediction: ?Object): boolean => {
  const types = prediction && prediction.types;
  if (!Array.isArray(types)) {
    return false;
  }
  return types.some(type => ADDRESS_PRIMARY_TYPES.includes(type));
};

export default isAddressPrediction;
